import Node from '../Node.js';

export default class ReturnStatement extends Node {
	// hasEffects () {
	// 	return true;
	// }
}
